export default "__VITE_ASSET__jPl1fT8e__"